import {VideoSubjectKind} from '@Components/ai-chat-window/components/assistant-message-image-part-animation-creations/assistant-message-image-part-animation-creations.types';
import {usePublishChatModelGeneratedImage} from '@Components/ai-chat-window/hooks/usePublishChatModelGeneratedImage';
import {useSaveToMyDesigns} from '@Components/ai-chat-window/hooks/useSaveToMyDesigns';
import {useOpenChatImageInEditor} from '@Components/ai-chat-window/hooks/useOpenChatImageInEditor';
import {useMakeTextEditable} from '@Components/ai-chat-window/hooks/useMakeTextEditable';
import {useTurnImageIntoVideo} from '@Components/ai-chat-window/hooks/useTurnImageIntoVideo';
import type {AssistantMessageImagePartActionsRowProps} from './assistant-message-image-part-actions-row.types';
import {ImageActionId} from './image-actions.types';
import type {UseImageActionHandlers} from './useImageActionHandlers.types';

export function useImageActionHandlers(props: AssistantMessageImagePartActionsRowProps): UseImageActionHandlers {
  const {publishToSocialMedia, publishAsEmailCampaign, promoteAsEvent} = usePublishChatModelGeneratedImage(props.chatId, props.hashedId);
  const {onSaveToMyDesigns} = useSaveToMyDesigns(props.chatId, props.hashedId);
  const {openPosterInEditor} = useOpenChatImageInEditor();
  const {makeTextEditable} = useMakeTextEditable({chatId: props.chatId});
  const {turnIntoVideo, isGeneratingVideo} = useTurnImageIntoVideo({chatId: props.chatId, hashedId: props.hashedId, videoSubject: {kind: VideoSubjectKind.GENERATED, imageHashedId: props.hashedId}, canWrite: props.canWrite});

  return {
    isGeneratingVideo,
    handlers: {
      [ImageActionId.TURN_INTO_VIDEO]: turnIntoVideo,
      [ImageActionId.DOWNLOAD]: props.onDownload,
      [ImageActionId.SHARE_DESIGN]: (): void => {
        void props.onShareDesign();
      },
      [ImageActionId.SAVE_TO_MY_DESIGNS]: (): void => {
        void onSaveToMyDesigns();
      },
      [ImageActionId.OPEN_IN_EDITOR]: (): void => {
        openPosterInEditor(props.hashedId);
      },
      [ImageActionId.MAKE_TEXT_EDITABLE]: (): void => {
        void makeTextEditable(props.hashedId, props.hasLayeredPoster);
      },
      [ImageActionId.PUBLISH_TO_SOCIAL_MEDIA]: (): void => {
        void publishToSocialMedia();
      },
      [ImageActionId.PUBLISH_AS_EMAIL_CAMPAIGN]: (): void => {
        void publishAsEmailCampaign();
      },
      [ImageActionId.PROMOTE_AS_EVENT]: (): void => {
        void promoteAsEvent();
      },
    },
  };
}
